import "./style.less";

export default function cookieDetails() {
    return {
        restrict: "E",
        scope: {
            isShown: "=",
        },
        template: require("./template.html"),
        controller: function ($scope, cookieModel) {
            $scope.cookies = cookieModel.cookies;
        },
    };
}
